import React from "react";
import { Helmet } from "react-helmet-async";
const PrivacyPolicy = () => {
  return (
    <div className="">
      <Helmet>
        <title>Privacy Policy - SabbaFarm (Sabba Farm)</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Read SabbaFarm's (Sabba Farm) Privacy Policy to understand how we collect, use, and protect your personal information while using our services."
        />

        {/* Meta Keywords - concise and relevant */}
        <meta
          name="keywords"
          content="SabbaFarm, Sabba Farm, privacy policy, data protection, personal data, information security, user privacy, farm product privacy"
        />

        {/* Robots for SEO */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://sabbafarm.com/privacy" />

        {/* Open Graph Tags for social sharing */}
        <meta
          property="og:title"
          content="Privacy Policy - SabbaFarm (Sabba Farm)"
        />
        <meta
          property="og:description"
          content="Learn how SabbaFarm (Sabba Farm) manages your personal data and ensures your privacy while using our services."
        />
        <meta property="og:url" content="https://sabbafarm.com/privacy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 py-10 text-gray-800 bg-white shadow-lg mb-16">
        <h1 className="text-3xl font-bold mb-3 text-green-700 " id="#privacy">
          Privacy Policy
        </h1>

        <p className="mb-2">
          This Privacy Policy applies to the <strong>sabbafarm.com</strong>
        </p>

        <p className="mb-2">
          Sabbafarm.com recognises the importance of maintaining your privacy.
          We value your privacy and appreciate your trust in us. This Policy
          describes how we treat user information we collect on{" "}
          <a
            href="https://www.sabbafarm.com"
            className="text-blue-600 underline"
          >
            https://www.sabbafarm.com
          </a>{" "}
          and other offline sources. This Privacy Policy applies to current and
          former visitors to our website and to our online customers. By
          visiting and/or using our website, you agree to this Privacy Policy.
        </p>

        <p className="mb-2">
          Sabbafarm.com is a property of{" "}
          <strong>SRI SANTHOSH SOWJANYA AGENCIES</strong>, an Indian PARTNERSHIP
          FIRM registered under the Andhra Pradesh Goods and Services Tax Act,
          2017, 1-5/3, Vedurupaka Road, Pasalapudi, ANDHRA PRADESH 533261.
        </p>

        <h2 className="text-2xl font-semibold mt-2 mb-2 text-green-600">
          Information we collect
        </h2>

        <ul className="list-disc list-inside space-y-2 mb-2">
          <li>
            <strong>Contact information:</strong> name, email, mobile number,
            phone number, street, city, state, pincode, country and IP address.
          </li>
          <li>
            <strong>Payment and billing information:</strong> billing name,
            billing address and payment method. We <strong>NEVER</strong>{" "}
            collect your credit card number or expiry date. Payment is handled
            by our partner <strong>CC Avenue</strong>.
          </li>
          <li>
            <strong>Information you post:</strong> content posted on public
            spaces on our website or third-party social media pages.
          </li>
          <li>
            <strong>Demographic information:</strong> details like products you
            buy, information provided via surveys.
          </li>
          <li>
            <strong>Other information:</strong> browser type, time spent, pages
            visited, referring sites, mobile device type, OS version.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-2 mb-2 text-green-600">
          How we collect information
        </h2>
        <ul className="list-disc list-inside space-y-2 mb-2">
          <li>
            Directly from you: when you register, buy, post comments, or ask
            questions. This includes mobile numbers for OTP verification.
          </li>
          <li>
            Passively: via tools like Google Analytics, Google Webmaster,
            cookies, and web beacons. We also use AWS services for sending OTPs
            for mobile number verification.
          </li>
          <li>
            From third-parties: integrated features from social media may
            provide your name and email address.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-2 mb-2 text-green-600">
          Use of your personal information
        </h2>
        <ul className="list-disc list-inside space-y-2 mb-2">
          <li>To contact you for confirmation or promotions.</li>
          <li>To respond to your queries or confirm registrations.</li>
          <li>To customize your experience and improve services.</li>
          <li>To analyze site trends and user interests.</li>
          <li>For security and fraud prevention, including mobile number verification via OTP.</li>
          <li>For marketing: to send promotions or newsletters.</li>
          <li>To send transactional communication (e.g., order updates, OTPs).</li>
          <li>As otherwise permitted by law.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-2 mb-2 text-green-600">
          Third-party sites
        </h2>
        <p className="mb-2">
          If you click on a third-party link, you may be taken to websites we do
          not control. This Privacy Policy does not apply to their practices.
          Please review their privacy policies carefully. Sabbafarm.com is not
          responsible for third-party site practices. Note that we utilize AWS
          services for sending OTPs for mobile number verification, and their privacy
          policies govern their handling of data.
        </p>

        <h2 className="text-2xl font-semibold mt-2 mb-2 text-green-600">
          Grievance Officer
        </h2>
        <p className="mb-2">
          In accordance with Information Technology Act 2000 and rules made
          there under, the name and contact details of the Grievance Officer are
          provided below:
        </p>
        <ul className="list-none mb-3">
          <li>
            <strong>Mr. SABBARAPU SANTOSH KUMAR</strong>
          </li>
          <li>SRI SANTHOSH SOWJANYA AGENCIES</li>
          <li>
            <strong>Phone:</strong> +91 9171749999
          </li>
          <li>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:customercare@sabbafarm.com"
              className="text-blue-600 underline"
            >
              customercare@sabbafarm.com
            </a>
          </li>
        </ul>

        <p className="text-sm text-gray-500">Last Updated: July 26, 2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;